// extracted by mini-css-extract-plugin
export default {"background_pic":"ChanceDetail_background_pic__iYK1B"};